import { cn } from "./classNames-DkX30VJU.js";
import { isMac } from "./utils-CLNKe1ar.js";
import { Children, Fragment } from "react";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Kbd/KbdSeparator.tsx
/** The `+` / `then` glue between two `Kbd` keys, in the muted chrome token. */
const KbdSeparator = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	...props,
	className: cn("tw:text-xs tw:text-muted-foreground", className)
});
// src/components/Kbd/KbdGroup.tsx
const KbdGroup = ({ ref, className, children, separator, ...props }) => {
	return /* @__PURE__ */ jsx("kbd", {
		...props,
		ref,
		className: cn("tw:inline-flex", "tw:items-center", "tw:gap-1", className),
		children: separator ? Children.toArray(children).map((child, index) => /* @__PURE__ */ jsxs(Fragment, { children: [index > 0 && /* @__PURE__ */ jsx(KbdSeparator, { children: separator }), child] }, index)) : children
	});
};
// src/components/Kbd/styles.ts
const kbdVariants = cva([
	"tailwindcss-preflight",
	"tw:pointer-events-none",
	"tw:w-fit",
	"tw:h-5",
	"tw:min-w-5",
	"tw:inline-flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:gap-1",
	"tw:shrink-0",
	"tw:px-1",
	"tw:[&_svg:not([class*=\"size-\"])]:size-2.5",
	"tw:text-xs",
	"tw:font-medium",
	"tw:rounded"
], {
	defaultVariants: {
		variant: "default",
		casing: "upper"
	},
	variants: {
		casing: {
			upper: "tw:uppercase",
			"as-written": ""
		},
		variant: {
			default: "tw:bg-muted tw:text-muted-foreground",
			primary: "tw:bg-muted tw:text-muted-foreground"
		}
	}
});
// src/components/Kbd/Kbd.tsx
const Kbd = ({ children, className, variant, casing, ...rest }) => /* @__PURE__ */ jsx("kbd", {
	...rest,
	className: kbdVariants({
		className,
		variant,
		casing
	}),
	children
});
Kbd.Group = KbdGroup;
Kbd.Separator = KbdSeparator;
// src/components/Kbd/keyboardKeys.ts
const KEY_DEFINITIONS = {
	mod: {
		mac: {
			symbol: "⌘",
			text: "Command"
		},
		windows: {
			symbol: "Ctrl",
			text: "Ctrl"
		}
	},
	option: {
		mac: {
			symbol: "⌥",
			text: "Option"
		},
		windows: {
			symbol: "Alt",
			text: "Alt"
		}
	},
	shift: {
		mac: {
			symbol: "⇧",
			text: "Shift"
		},
		windows: {
			symbol: "⇧",
			text: "Shift"
		}
	},
	enter: {
		mac: {
			symbol: "⏎",
			text: "Enter"
		},
		windows: {
			symbol: "⏎",
			text: "Enter"
		}
	}
};
const createKeyboardKeys = () => {
	const keysObj = {};
	for (const keyName of Object.keys(KEY_DEFINITIONS)) keysObj[keyName] = KEY_DEFINITIONS[keyName][isMac ? "mac" : "windows"];
	return keysObj;
};
const keys = createKeyboardKeys();
export { Kbd, kbdVariants, keys };

//# sourceMappingURL=Kbd-D4F65jXO.js.map